// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHotspotModal_videoContainer__rUIRr","video":"VideoHotspotModal_video__xq9JC","hotspotContainer":"VideoHotspotModal_hotspotContainer__aSbyp"};